// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qbsCy","fullWidth":"styles_fullWidth__PdYJ8"};